export default "__VITE_ASSET__h8Urh$8R__"